import { Stack, Text } from '@mantine/core'
import React from 'react'
import { useTheme } from '../../../components/ThemeProvider'

interface CriminalCaseProps {
  number: number
  item: any
}

const formatAmount = (amount: any) => {
  if (amount === '' || amount === null || amount === undefined) {
    return undefined
  }
  return `¥${amount}`
}

export default function CriminalCase({ number, item }: CriminalCaseProps) {
  const caseObj = item?.caseObj || item
  const theme = useTheme()

  const headerFields = [
    { label: '案号', value: caseObj?.caseCode },
    { label: '案件类型', value: caseObj?.caseType },
    { label: '诉讼地位', value: caseObj?.casePosition },
    { label: '经办法院', value: caseObj?.courtName },
    { label: '立案时间', value: caseObj?.caseRegTime },
    { label: '案件状态', value: caseObj?.caseStatus },
  ].filter((field) => field.value)

  const amountFields = [
    { label: '定罪罪名', value: caseObj?.convictionCharge },
    { label: '判处结果', value: caseObj?.judgmentResult },
    { label: '犯罪金额', value: formatAmount(caseObj?.crimeAmount) },
    { label: '判处赔偿金额', value: formatAmount(caseObj?.judgmentCompensation) },
    { label: '财产刑执行金额', value: formatAmount(caseObj?.propertyPenaltyAmount) },
  ].filter((field) => field.value)

  const extraFields = [
    { label: '结案时间', value: caseObj?.caseEndTime },
    { label: '审理程序', value: caseObj?.trialProcedure },
    { label: '结案方式', value: caseObj?.caseEndMethod },
    { label: '当事人', value: caseObj?.parties },
    { label: '原审案号', value: caseObj?.originalCaseCode },
    { label: '后续案号', value: caseObj?.subsequentCaseCode },
  ].filter((field) => field.value)

  return (
    <div
      className="rounded-lg border px-4 py-4"
      style={{ borderColor: theme.surfaceBorderColor, backgroundColor: theme.surfaceColor }}
    >
      <Stack gap="sm">
        <Text size="xs" c="dimmed">
          案件 {number}
        </Text>
        {headerFields.length > 0 && (
          <div className="grid gap-3 md:grid-cols-2">
            {headerFields.map((field) => (
              <FieldRow key={field.label} label={field.label} value={field.value} />
            ))}
          </div>
        )}
        {amountFields.length > 0 && (
          <div className="grid gap-3 md:grid-cols-2">
            {amountFields.map((field) => (
              <FieldRow key={field.label} label={field.label} value={field.value} />
            ))}
          </div>
        )}
        {extraFields.length > 0 && (
          <div className="grid gap-3 md:grid-cols-2">
            {extraFields.map((field) => (
              <FieldRow key={field.label} label={field.label} value={field.value} />
            ))}
          </div>
        )}
      </Stack>
    </div>
  )
}

interface FieldRowProps {
  label: string
  value?: string
}

function FieldRow({ label, value }: FieldRowProps) {
  return (
    <div className="flex flex-col gap-1">
      <Text size="xs" c="dimmed">
        {label}
      </Text>
      <Text size="sm" className="text-gray-700" fw={500}>
        {value || '—'}
      </Text>
    </div>
  )
}
